export default {

    postAddNewClient: function(client) {
        return axios.post('/api/clients',
            client, {successHandle: true},
        );
    },

}
